/**
 * Yotpo Reviews – desktop Filters toggle.
 * Yotpo only renders a Filters button in its small layout; on wider layouts its filter
 * dropdowns sit inline. This adds a matching Filters button right after the search, and
 * its aria-expanded state shows those dropdowns as a panel (styled in
 * yotpo-reviews-product.css). Yotpo's own nodes are never moved, so its re-renders stay intact.
 * Used by sections/product-information.liquid.
 */
(function () {
  var TOGGLE_CLASS = 'vb-yotpo-filters-toggle';
  var SEARCH_SELECTOR = '.yotpo-free-search-filter-container';
  var PANEL_ITEM_SELECTOR = '.' + TOGGLE_CLASS + ' ~ :not(' + SEARCH_SELECTOR + ')';
  var OPEN_LISTBOX_SELECTOR = '#yotpo-reviews-main-widget [role="combobox"][aria-expanded="true"]';
  var script = document.currentScript;
  var label = (script && script.dataset.filtersLabel) || 'Filters';
  var scheduled = false;

  function getToggle() {
    return document.querySelector('#yotpo-reviews-main-widget .' + TOGGLE_CLASS);
  }

  function isOpen(toggle) {
    return toggle.getAttribute('aria-expanded') === 'true';
  }

  function setOpen(toggle, open) {
    toggle.setAttribute('aria-expanded', String(open));
  }

  function createToggle() {
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = TOGGLE_CLASS;
    toggle.textContent = label;
    setOpen(toggle, false);
    toggle.addEventListener('click', function () {
      setOpen(toggle, !isOpen(toggle));
    });
    return toggle;
  }

  /** @param {Element} topPanel */
  function hasFilterDropdowns(topPanel) {
    return Array.prototype.some.call(topPanel.children, function (child) {
      return !child.matches(SEARCH_SELECTOR + ', .' + TOGGLE_CLASS);
    });
  }

  // The toggle must sit directly after the search: the CSS sibling selectors (and the
  // tab order) treat every element after it in the top panel as part of the panel.
  function ensureToggle() {
    var topPanel = document.querySelector('#yotpo-reviews-main-widget .yotpo-filters-top-panel');
    if (!topPanel) return;

    var toggle = topPanel.querySelector('.' + TOGGLE_CLASS);
    var search = topPanel.querySelector(':scope > ' + SEARCH_SELECTOR);
    var hasYotpoButton = Boolean(topPanel.querySelector('.yotpo-mobile-filters-popup-btn'));

    if (hasYotpoButton || !search || !hasFilterDropdowns(topPanel)) {
      if (toggle) toggle.remove();
      return;
    }

    var nextToggle = toggle || createToggle();
    if (search.nextElementSibling !== nextToggle) search.after(nextToggle);
  }

  function scheduleEnsureToggle() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      ensureToggle();
    });
  }

  /** @param {MouseEvent} event */
  function closeOnOutsideClick(event) {
    var toggle = getToggle();
    if (!toggle || !isOpen(toggle)) return;

    // composedPath() still holds nodes Yotpo detaches while handling the same click.
    var isInside = event.composedPath().some(function (node) {
      return node === toggle || (node instanceof Element && node.matches(PANEL_ITEM_SELECTOR));
    });
    if (!isInside) setOpen(toggle, false);
  }

  /** @param {KeyboardEvent} event */
  function closeOnEscape(event) {
    if (event.key !== 'Escape') return;
    var toggle = getToggle();
    if (!toggle || !isOpen(toggle)) return;
    // An open Yotpo listbox handles this Escape itself; the panel closes on the next one.
    if (document.querySelector(OPEN_LISTBOX_SELECTOR)) return;

    var focused = document.activeElement;
    var focusInPanel = Boolean(focused && focused.closest(PANEL_ITEM_SELECTOR));
    setOpen(toggle, false);
    if (focusInPanel) toggle.focus();
  }

  ensureToggle();
  new MutationObserver(scheduleEnsureToggle).observe(document.body, {
    childList: true,
    subtree: true,
  });
  document.addEventListener('click', closeOnOutsideClick);
  // Capture phase: Yotpo's dropdowns stop Escape from bubbling.
  document.addEventListener('keydown', closeOnEscape, true);
})();
